module.exports = __webpack_public_path__ + "static/media/dxa-real-time-triggers.20fcfd08.md";